<template>
  <div class="flex flex-col flex-1 h-full overflow-hidden">
    <router-view />
  </div>
</template>
